"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var MessageAdListItem_1 = require("./MessageAdListItem");
var mobx_react_1 = require("mobx-react");
var owa_mail_messagead_list_store_1 = require("owa-mail-messagead-list-store");
var owa_mail_messagead_orchestration_1 = require("owa-mail-messagead-orchestration");
var store_1 = require("owa-mail-messagead-store/lib/store/store");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var ReadingPanePosition_1 = require("owa-session-store/lib/store/schema/ReadingPanePosition");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var MessageAdList = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdList, _super);
    function MessageAdList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageAdList.prototype.componentDidMount = function () {
        owa_mail_messagead_orchestration_1.loadMessageAdList(store_1.getStore().adIds == null || store_1.getStore().adIds.length == 0 ? 'init' : 'refresh');
    };
    MessageAdList.prototype.render = function () {
        var isReadingPanePositionOff = getUserConfiguration_1.default().UserOptions.GlobalReadingPanePositionReact ===
            ReadingPanePosition_1.default.Off;
        return (React.createElement("div", { className: isReadingPanePositionOff
                ? styles.messageAdStaticContainerReadingPaneOff
                : styles.messageAdStaticContainerReadingPaneOn }, store_1.getStore().adIds.map(function (adId) {
            return (React.createElement(MessageAdListItem_1.default, { key: adId, messageAd: store_1.getStore().messageAdRowStore.get(adId), isSelected: adId == owa_mail_messagead_list_store_1.messageAdListViewStatusStore.selectedAdId, isReadingPanePositionOff: isReadingPanePositionOff }));
        })));
    };
    MessageAdList = tslib_1.__decorate([
        mobx_react_1.observer
    ], MessageAdList);
    return MessageAdList;
}(React.Component));
exports.default = MessageAdList;
//# sourceMappingURL=MessageAdList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/MessageAdList.js
// module id = 5994
// module chunks = 67